export const defaultFilters = {
    category: "general",
    keywords: [],
    countries: [],
    dateRange: "1",
    match: "or",
  };

  export const countries = [
      { code: "us", name: "USA" },
      { code: "gb", name: "UK" },
      { code: "ca", name: "Canada" },
      { code: "au", name: "Australia" }
  ];
  
  export const categories = [
      "general", "world", "nation", "business", "technology",
      "entertainment", "sports", "science", "health"
  ];
  
  export const dateOptions = [
      { label: "Today", value: "1" },
      { label: "Last 3 Days", value: "3" },
      { label: "Last Week", value: "7" },
      { label: "All Time", value: "all" },
      { label: "Select Range", value: "range" },
  ];
  
  export const matchOptions = [
      { label: "Match Any", value: "or" },
      { label: "Match All", value: "and" },
  ];
  